<template>
  <b-card no-body class="pt-0">
    <b-card-body>
      <vue-apex-charts
        ref="lineChart"
        type="line"
        height="330"
        :options="lineChart.chartOptions"
        :series="lineChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BBadge,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import chartColor from "./ChartColor";
export default {
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
  },
  props: {
    titleText: {
      type: String,
      default: "",
    },
    xaxisCategories: {
      type: Array,
      default: () => [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ],
    },
    filter: {
      type: Object,
      default: () => ({
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
      }),
      // default: function() {
      //   return new {
      //     year: new Date().getFullYear().toString(),
      //     yearEnd: new Date().getFullYear().toString(),
      //     startDate: "",
      //     endDate: "",
      //     userId: userData.userId(),
      //     departmentId: userData.departmentId(),
      //   }();
      // },
      // default: {
      //   year: new Date().getFullYear().toString(),
      //   yearEnd: new Date().getFullYear().toString(),
      //   startDate: "",
      //   endDate: "",
      //   userId: userData.userId(),
      //   departmentId: userData.departmentId(),
      // },
    },
  },
  data() {
    return {
      chartColor,
      min: 1,
      max: 100,
      seriesCustomize: {
        name: "",
        data: [],
      },
      lineChart: {
        series: [], // customize=>seriesCustomize
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            // strokeWidth: 5,
            // strokeOpacity: 1,
            // strokeColors: [$themeColors.light],
            // colors: [$themeColors.warning],
          },
          // colors: [$themeColors.warning],
          colors: [],
          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: "smooth",
            // curve: ["straight", "smooth", "monotoneCubic", "stepline"], // กรณีมีหลายเส้น
          },
          title: {
            text: this.titleText, // props=>titleText
            align: "left",
            style: {
              fontSize: "18px",
              // fontWeight:  'bold',
            },
          },
          grid: {
            xaxis: {
              lines: {
                // show: true,
                show: false,
              },
            },
          },
          // tooltip: {
          //   custom(data) {
          //     return `${'<div class="px-1 py-50"><span>'}${
          //       data.series[data.seriesIndex][data.dataPointIndex]
          //     } เรื่อง</span></div>`
          //   },
          // },
          xaxis: {
            categories: this.xaxisCategories, // prop=>xaxisCategories
          },
          yaxis: {
            // opposite: isRtl,
          },
          noData: {
            text: "ไม่พบข้อมูล",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "18px",
              fontFamily: undefined,
            },
          },
        },
      },
    };
  },
  mounted() {
    this.funcGetComplaintPerMonth(this.filter);
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    async getRandomChartColor(n) {
      const self = this;
      // //console.log"linechart.randomchartcolor .n", n);

      const result = [];
      const colors = [...self.chartColor.color];
      // //console.log"linechart.randomchartcolor .colors", colors);

      while (result.length < n) {
        const shuffled = colors.sort(() => Math.random() - 0.5);
        const remaining = n - result.length;
        const takeCount = Math.min(remaining, shuffled.length);
        result.push(...shuffled.slice(0, takeCount));
      }

      // //console.log"linechart.randomchartcolor .result", result);

      self.lineChart.chartOptions.colors = [...result];
      // return [...result];
    },
    funcGetComplaintPerMonth(parameter) {
      // //console.log"linechart.complaintpermount .parameter 1", parameter);
      const self = this;

      if (parameter.startDate) {
        parameter.year = parameter.startDate.split("-")[0];
      }
      if (parameter.endDate) {
        parameter.yearEnd = parameter.endDate.split("-")[0];
      }
      // //console.log"linechart.complaintpermount .parameter 2", parameter);

      apiDashboard
        .GetLineChart_ComplaintPerMonth(parameter)
        .then(async (response) => {
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            // //console.log"linechart.complaintpermount .response", response);

            // self.lineChart.series = [];
            self.lineChart.series = [...response.data.data];
            // self.lineChart.chartOptions.colors = await self.getRandomChartColor(response.data.data.length);
            await self.getRandomChartColor(response.data.data.length);

            // if (response && response.data && response.data.data && response.data.data.length > 0) {
            //   self.lineChart.series = response.data.data;
            // }
            // if (response && response.data && response.data.data && response.data.data.length > 0) {
            //   await this.getRandomChartColor(response.data.data.length);
            // }
            self.updateLineChart();
          }
        })
        .catch((error) => {
          //console.log"error", error);
        });
    },
    updateLineChart() {
      this.$refs["lineChart"].updateSeries([
        {
          data: this.lineChart.series
        },
        false,
        true,
      ]);

      // this.$refs["lineChart"].updateOptions({
      //   labels: this.lineChart.chartOptions.labels,
      // });
      this.$refs["lineChart"].refresh();
    },
    myEventHandler(e) {
      this.$refs["lineChart"].refresh();
    },
  },
};
</script>